module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 33);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("classnames/bind");

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = InlineGrid;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _align = __webpack_require__(10);

var _align2 = _interopRequireDefault(_align);

var _general = __webpack_require__(11);

var _general2 = _interopRequireDefault(_general);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind2.default.bind(_extends({}, _align2.default, _general2.default));

/**
 * A simpler grid implementation for when you need to quickly inline elements.
 * The optional `size` prop is available as well as vertical alignment with the
 * `align` prop.
 */
function InlineGrid(_ref) {
  var align = _ref.align,
      children = _ref.children,
      size = _ref.size,
      sizeL = _ref.sizeL,
      sizeM = _ref.sizeM,
      sizeS = _ref.sizeS,
      startAfterL = _ref.startAfterL,
      startAfterM = _ref.startAfterM,
      startAfterS = _ref.startAfterS;

  var wrappedChildren = _react.Children.map(children, function (child, index) {
    var _cx;

    if (!child) {
      return null;
    }
    var lastChild = children.length - 1 === index;
    var className = cx((_cx = {}, _defineProperty(_cx, 'marginBottom-' + size, !lastChild && (startAfterS || startAfterM || startAfterL)), _defineProperty(_cx, 'marginRight-' + size, !lastChild && !startAfterS && !startAfterM && !startAfterL), _defineProperty(_cx, 'breakPointS-marginRight-' + sizeS, !lastChild && sizeS), _defineProperty(_cx, 'breakPointM-marginRight-' + sizeM, !lastChild && sizeM), _defineProperty(_cx, 'breakPointL-marginRight-' + sizeL, !lastChild && sizeL), _defineProperty(_cx, 'breakPointS-marginBottom-0', !lastChild && startAfterS), _defineProperty(_cx, 'breakPointM-marginBottom-0', !lastChild && startAfterM), _defineProperty(_cx, 'breakPointL-marginBottom-0', !lastChild && startAfterL), _cx));
    return _react2.default.createElement(
      'div',
      { key: index, className: className },
      child
    );
  });

  var containerClasses = cx([align], {
    'display-flex': !startAfterS && !startAfterM && !startAfterL,
    'breakPointS-display-flex': startAfterS,
    'breakPointM-display-flex': startAfterM,
    'breakPointL-display-flex': startAfterL
  });

  return _react2.default.createElement(
    'div',
    { className: _general2.default.wrap },
    _react2.default.createElement(
      'div',
      { className: containerClasses },
      wrappedChildren
    )
  );
}

InlineGrid.propTypes = {
  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom']),
  children: _propTypes2.default.node.isRequired,
  size: _propTypes2.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs', 'none']),
  sizeL: _propTypes2.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs', 'none']),
  sizeM: _propTypes2.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs', 'none']),
  sizeS: _propTypes2.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs', 'none']),
  startAfterS: _propTypes2.default.bool,
  startAfterM: _propTypes2.default.bool,
  startAfterL: _propTypes2.default.bool
};

InlineGrid.defaultProps = {
  align: 'middle',
  size: 'm',
  startAfterS: false,
  startAfterM: false,
  startAfterL: false
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"top":"align__top___23GkX alignItems-flexStart","middle":"align__middle___36vRU alignItems-center","bottom":"align__bottom___lPiYq alignItems-flexEnd"};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrap":"general__wrap___kYC0C display-inlineBlock"};

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineGrid = exports.GridItem = undefined;

var _GridItem = __webpack_require__(45);

Object.defineProperty(exports, 'GridItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridItem).default;
  }
});

var _InlineGrid = __webpack_require__(9);

Object.defineProperty(exports, 'InlineGrid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineGrid).default;
  }
});

var _Grid = __webpack_require__(49);

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Grid2.default;

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GridItem;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _general = __webpack_require__(46);

var _general2 = _interopRequireDefault(_general);

var _alignContent = __webpack_require__(47);

var _alignContent2 = _interopRequireDefault(_alignContent);

var _justifyContent = __webpack_require__(48);

var _justifyContent2 = _interopRequireDefault(_justifyContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MAX_COLUMNS = 12;
var PCT_ROUND = 5;

function GridItem(_ref) {
  var _cx;

  var alignContent = _ref.alignContent,
      children = _ref.children,
      columns = _ref.columns,
      columnSpan = _ref.columnSpan,
      columnSpanS = _ref.columnSpanS,
      columnSpanM = _ref.columnSpanM,
      columnSpanL = _ref.columnSpanL,
      fullWidth = _ref.fullWidth,
      justifyContent = _ref.justifyContent;

  var width = fullWidth ? 'width-100' : getWidthClassName(columnSpan, columns);
  var className = (0, _classnames2.default)(_general2.default.gridItem, _alignContent2.default[alignContent], _justifyContent2.default[justifyContent], width, (_cx = {}, _defineProperty(_cx, 'breakPointS-' + getWidthClassName(columnSpanS, columns), columnSpanS), _defineProperty(_cx, 'breakPointM-' + getWidthClassName(columnSpanM, columns), columnSpanM), _defineProperty(_cx, 'breakPointL-' + getWidthClassName(columnSpanL, columns), columnSpanL), _cx));
  return _react2.default.createElement(
    'li',
    { className: className },
    children
  );
}

function getWidthClassName(columnSpan, columns) {
  // fraction-based
  if (MAX_COLUMNS % columns === 0) {
    var scale = MAX_COLUMNS / columns;
    var numerator = columnSpan * scale;
    var denominator = columns * scale;
    return 'width-' + numerator + '/' + denominator;
  }
  // percentage-based
  return roundToNearestN(100 / columns * columnSpan, PCT_ROUND);
}

function roundToNearestN(i, N) {
  return Math.ceil(i / N) * N;
}

GridItem.propTypes = {
  alignContent: _propTypes2.default.oneOf(Object.keys(_alignContent2.default)),
  justifyContent: _propTypes2.default.oneOf(Object.keys(_justifyContent2.default)),
  children: _propTypes2.default.node.isRequired,
  columns: _propTypes2.default.number,
  columnSpan: _propTypes2.default.number,
  columnSpanS: _propTypes2.default.number,
  columnSpanM: _propTypes2.default.number,
  columnSpanL: _propTypes2.default.number,
  fullWidth: _propTypes2.default.bool
};

GridItem.defaultProps = {
  columns: 2,
  columnSpan: 1,
  columnSpanS: null,
  columnSpanM: null,
  columnSpanL: null,
  fullWidth: false
};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gridItem":"general__gridItem___33eeJ boxSizing-borderBox listStyle-none"};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"center":"alignContent__center___1t9vf alignContent-center","end":"alignContent__end___3FyDa alignContent-end","flex-end":"alignContent__flex-end___csgYh alignContent-flexEnd","flex-start":"alignContent__flex-start___hgnOq alignContent-flexStart","space-around":"alignContent__space-around___3fwYK alignContent-spaceAround","space-between":"alignContent__space-between___vyKHf alignContent-spaceBetween","space-evenly":"alignContent__space-evenly___2Ec8H alignContent-spaceEvenly","start":"alignContent__start___3qazv alignContent-start","stretch":"alignContent__stretch___sLnja alignContent-stretch"};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"center":"justifyContent__center___3Gzsn justifyContent-center","end":"justifyContent__end___1QP6z justifyContent-end","flex-end":"justifyContent__flex-end___3fW_8 justifyContent-flexEnd","flex-start":"justifyContent__flex-start___1VyG6 justifyContent-flexStart","space-around":"justifyContent__space-around___1nRyH justifyContent-spaceAround","space-between":"justifyContent__space-between___1DRnN justifyContent-spaceBetween","space-evenly":"justifyContent__space-evenly___2zW-1 justifyContent-spaceEvenly","start":"justifyContent__start___29cBW justifyContent-start","stretch":"justifyContent__stretch___2lT3S justifyContent-stretch"};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Grid;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _general = __webpack_require__(50);

var _general2 = _interopRequireDefault(_general);

var _alignItems = __webpack_require__(51);

var _alignItems2 = _interopRequireDefault(_alignItems);

var _alignContent = __webpack_require__(52);

var _alignContent2 = _interopRequireDefault(_alignContent);

var _justifyContent = __webpack_require__(53);

var _justifyContent2 = _interopRequireDefault(_justifyContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = ['none', 'xxs', 'xs', 's', 'm', 'l', 'xl'];
var items = ['baseline', 'center', 'flex-end', 'flex-start', 'stretch'];
var content = ['center', 'end', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly', 'start', 'stretch'];

/**
 * A simple, responsive CSS flexbox grid to be used in combination with
 * `GridItem` to create complex layouts. The standard flexbox properties for
 * `align-items`, `align-content` and `justify-content` are available.
 */
function Grid(_ref) {
  var _cx;

  var alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      children = _ref.children,
      columns = _ref.columns,
      justifyContent = _ref.justifyContent,
      size = _ref.size,
      sizeL = _ref.sizeL,
      sizeM = _ref.sizeM,
      sizeS = _ref.sizeS;

  var childrenWithProps = _react2.default.Children.map(children, function (child) {
    return child ? _react2.default.cloneElement(child, { columns: columns, columnGap: sizes[size] }) : null;
  });

  var classes = (0, _classnames2.default)(_general2.default.grid, _alignItems2.default[alignItems], _alignContent2.default[alignContent], _justifyContent2.default[justifyContent], 'grid--' + size, (_cx = {}, _defineProperty(_cx, 'breakPointS-grid--' + sizeS, sizeS), _defineProperty(_cx, 'breakPointM-grid--' + sizeM, sizeM), _defineProperty(_cx, 'breakPointL-grid--' + sizeL, sizeL), _cx));

  return _react2.default.createElement(
    'ul',
    { className: classes },
    childrenWithProps
  );
}

Grid.propTypes = {
  alignContent: _propTypes2.default.oneOf(content),
  alignItems: _propTypes2.default.oneOf(items),
  children: _propTypes2.default.node.isRequired,
  columns: _propTypes2.default.number,
  justifyContent: _propTypes2.default.oneOf(content),
  size: _propTypes2.default.oneOf(sizes),
  sizeL: _propTypes2.default.oneOf(sizes),
  sizeM: _propTypes2.default.oneOf(sizes),
  sizeS: _propTypes2.default.oneOf(sizes)
};

Grid.defaultProps = {
  columns: 2,
  size: 'm'
};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grid":"general__grid___tNY7l display-flex flexWrap-wrap"};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flex-start":"alignItems__flex-start___1GlNL alignItems-flexStart","flex-end":"alignItems__flex-end___VnOFT alignItems-flexEnd","center":"alignItems__center___2bDs8 alignItems-center","baseline":"alignItems__baseline___JSPkg alignItems-baseline","stretch":"alignItems__stretch___pQcas alignItems-stretch"};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"center":"alignContent__center___3A8S- alignContent-center","end":"alignContent__end___2jYD8 alignContent-end","flex-end":"alignContent__flex-end___1_1uS alignContent-flexEnd","flex-start":"alignContent__flex-start___j7k3l alignContent-flexStart","space-around":"alignContent__space-around___3Jwff alignContent-spaceAround","space-between":"alignContent__space-between___YvbhJ alignContent-spaceBetween","space-evenly":"alignContent__space-evenly___2GhxG alignContent-spaceEvenly","start":"alignContent__start___2ouYt alignContent-start","stretch":"alignContent__stretch___2sGzP alignContent-stretch"};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"center":"justifyContent__center___12K5q justifyContent-center","end":"justifyContent__end___2tadK justifyContent-end","flex-end":"justifyContent__flex-end___3ou_g justifyContent-flexEnd","flex-start":"justifyContent__flex-start___3fOfS justifyContent-flexStart","space-around":"justifyContent__space-around___1xkEg justifyContent-spaceAround","space-between":"justifyContent__space-between___21dfA justifyContent-spaceBetween","space-evenly":"justifyContent__space-evenly___HvDEz justifyContent-spaceEvenly","start":"justifyContent__start___3NKG2 justifyContent-start","stretch":"justifyContent__stretch___30PBD justifyContent-stretch"};

/***/ })
/******/ ]);
//# sourceMappingURL=marvel-ui-grid.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-grid.js
// module id = 1101
// module chunks = 168707334958949